export default "/images/register-1.png?7534b25e509e7a2432b28f674e1184fd";